export const clamp = (v: number, lo: number, hi: number) => v < lo ? lo : v > hi ? hi : v;
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
export const distSq = (ax: number, ay: number, bx: number, by: number) => {
  const dx = ax - bx, dy = ay - by; return dx * dx + dy * dy;
};
export const dist = (ax: number, ay: number, bx: number, by: number) => Math.sqrt(distSq(ax, ay, bx, by));
export const TAU = Math.PI * 2;

/**
 * Frame-rate-independent exponential smoothing. `rate` is how fast we
 * converge, in 1/seconds. A rate of 10 means we close ~63% of the gap each
 * 1/10th of a second regardless of framerate.
 */
export const smoothApproach = (current: number, target: number, rate: number, dt: number) => {
  const t = 1 - Math.exp(-rate * dt);
  return current + (target - current) * t;
};
